import React from 'react';
import {Card, CardContent, Grid } from '@mui/material';
import styles from 'styles/informacionDelCard';
import TituloConIcono from 'components/tituloConIcono';
import ElementoDelCard from 'components/card/ElementoDelCard';
import Television from './Television';
import Radio from './Radio';
import Exterior from './Exterior';
import Escrito from './Escrito';

const CaracteristicasDelMedio = ({datosGeneralesDeSolicitud, obtenerDocumentoAdjunto}) => {
  const classes = styles();
  const { solicitudTV, solicitudRadio, solicitudEscrito, solicitudExteriores} = datosGeneralesDeSolicitud;

  return (
    <Card className={classes.root}>
        <CardContent>
          <Grid container spacing={2} justifyContent="flex-start" alignItems="stretch" m={1}>
            {solicitudTV?.length > 0 ? (
              <Grid item xs={12}>
                <TituloConIcono title={`TELEVISIÓN`} mostrarTiempo={false} mostrarBotones={false} showDivider={false} icon="television" />
                <Television televisions={solicitudTV} obtenerDocumentoAdjunto={obtenerDocumentoAdjunto} />
              </Grid>
            ) : null}

            {solicitudRadio?.length > 0 ? (
              <Grid item xs={12}>
                <TituloConIcono title={`RADIO`} mostrarTiempo={false} mostrarBotones={false} showDivider={false} icon="radio" />
                <Radio radios={solicitudRadio} obtenerDocumentoAdjunto={obtenerDocumentoAdjunto} />
              </Grid>
            ) : null}

            {solicitudEscrito?.length > 0 ? (
            <Grid item xs={12}>
                <TituloConIcono title={`ESCRITO`} mostrarTiempo={false} mostrarBotones={false} showDivider={false} icon="escritos" />
                <Escrito escritos={solicitudEscrito} />
            </Grid>
            ) : null}

            {solicitudExteriores?.length > 0 ? (
            <Grid item xs={12}>
              <TituloConIcono title={`MEDIOS ALTERNATIVOS`} mostrarTiempo={false} mostrarBotones={false} showDivider={false} icon="vallas_fijas" />
              <Exterior datosGeneralesDeSolicitud={datosGeneralesDeSolicitud} />
            </Grid>
            ) : null}
          </Grid>
        </CardContent>
    </Card>
  );
}

export default CaracteristicasDelMedio;